export default __webpack_public_path__ + "static/5-14957d67f750e6b5bff21d85a3c4a3d6.jpg";